const delay = (t, v) => {
    return new Promise(function (resolve) {
        setTimeout(resolve.bind(null, v), t)
    });
}

const scrollY = () => window.scrollY || document.documentElement.scrollTop

export { delay, scrollY }